<template>
  <div id="app" v-if="isAuthenticated" :style="cssVars" :class="componentStyle.mode">
    <vue-progress-bar></vue-progress-bar>
    <component :is="layout" v-if="currentSkin">
      <router-view />
    </component>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { service, service_Skin } from './service';

const defaultLayout = 'default';

export default {


  name: 'App',
  data() {
    return {
      isAuthenticated: false,
    };
  },
  metaInfo: {
    title: process.env.META_TITLA,
    titleTemplate: '%s | ' + process.env.META_TITLA,
    meta: [
      {
        name: 'description',
        content: process.env.META_DESCRIPTION,
      },
    ],
  },
  computed: {
    ...mapGetters({
      componentStyle: 'layout/getComponentStyle',

      currentSkin: 'layout/getCurrentSkin',
      getColorTheme: 'layout/getColorTheme',
      currentPrimaryColor: 'layout/getCurrentPrimaryColor',
      currentSecondaryColor: 'layout/getCurrentSecondaryColor',
      currentBackgroundColor: 'layout/getCurrentBackgroundColor',
    }),
    layout() {
      return `${this.$route.meta.layout || defaultLayout}-layout`;
    },
    cssVars() {

      if(process.env.HAS_SKIN){
        console.log("process.env.HAS_SKIN")
        return {
          '--secondary-color': this.currentSecondaryColor ,
          '--primary-color': this.currentPrimaryColor ,
          '--color-title': this.currentPrimaryColor ,
          '--background-color':this.currentBackgroundColor ,
        };

      }


    },
  },
  methods: {
    ...mapActions('videos', [
      'setCurrentTheme',
      'setKeyword',
      'setCurrentCategory',
      'paginateVideos',
    ]),
    ...mapActions('themes', ['fetchThemes']),
    ...mapActions('layout', [
      'fetchCurrentSkin',
      'fetchTemplateOptions',
      'setCurrentPrimaryColor',
      'setCurrentSecondaryColor',
      'setCurrentSkinPlayer',
      'setCurrentLogo',
      'setIsSiteEmbed'
    ]),
    ...mapActions('common', ['getUserParams']),
    ...mapActions('custom', ['setAuthenticateSaml']),

    listenPostMessage() {
      let self = this;
      if (window.dataEventPostMessage === undefined) {
        window.dataEventPostMessage = true;
        var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
        var eventer = window[eventMethod];
        var messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';
        eventer(
          messageEvent,
          function(event) {
            var message = event.data;
            if (message !== 'undefined') {
              if (message.info === 'updateColorTheme') {
                  document.getElementById('app').style.setProperty(message.name, message.value);
              }
              if (message.info === 'updateColorTitleTheme') {
                  document.getElementById('app').style.setProperty(message.name, message.value);
              }
              if (message.info === 'updateLogoTheme') {
                self.setCurrentLogo(message.imgDataUrl);
                var imgDataUrl = message.imgDataUrl;
                var image_base64 = document.querySelectorAll('.image_base64');
                image_base64.forEach(image => {
                  image.src = imgDataUrl;
                });
              }
              if (message.info === 'updateSkinPlayerTheme') {
                self.setCurrentSkinPlayer(message.skin);
                window.eventHub.$emit('skinPlayerUpdated');
              }
            }
          },
          false,
        );
      }
    },
  },
  mounted() {
    const themeId = this.$route.params.themeId;
    const keyword = this.$route.query.q;
    if (keyword) {
      this.$router.push({ query: { q: keyword } });
    } else {
      if(this.$route.params.category){
        const currentCategory = this.$route.params.category ;
        this.setCurrentCategory(currentCategory);
      }else if( this.$route.name == 'theme'){
        this.setCurrentCategory('all');
      }
      if (themeId) {
        this.setCurrentTheme(themeId);
      }
      //this.paginateVideos();
    }
    this.listenPostMessage();
  },
  async created() {

    const user = this.$route.params.user ? this.$route.params.user : "";
    if (user) {
      service.updateService({ user });
    }
      let type='vod';
      if (process.env.HAS_SKIN) {
      const idUrl = this.$route.params.optionId || this.$route.query.optionId;
      const idChannel = process.env.ID_CHANNEL;
      let id = idUrl ? idUrl : '0';
     await this.fetchTemplateOptions({ id, idChannel , type, user});
    }
    this.fetchCurrentSkin();
    try {
      await this.getUserParams();
      this.isAuthenticated = true;
    } catch (e) {
      this.isAuthenticated = true;
      console.error(e);
    }
    if (this.$route.name ==='embedSite'){
        this.setIsSiteEmbed(true);
    }


     /* Barreau Authenticate SSO*/
    if(this.componentStyle.customMain)
    this.setAuthenticateSaml();





  },
};
</script>

<style lang="scss">
  @import '@/assets/scss/_colors.scss';

  @import "/assets/scss/mix.scss";
@import "/assets/scss/fonts/demo_style.css";
@import "/assets/scss/fonts/fonts.css";

@import '@/assets/scss/_variables.scss';
@import '../node_modules/bootstrap/scss/bootstrap.scss';

@import '/assets/scss/main.scss';


:root {

  --primary-color: #{$primary-color};
  --secondary-color: #{$secondary-color};
  --color-title:#{$color-title};


}
#app {
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #444444;
  min-height: 100vh;
  background-color: var(--background-color,#fafafa);
}
.component .uep_player .video-player .video-js {
  height: 100%;
  min-height: 100%;
}
.uep-comments-list.max-w-3xl.mx-auto.with-user {
  margin-left: 10px !important;
  border: 1px solid #ced4da;
  .comment-title{
    background : var(--secondary-color)!important;
    .dropdown-menu {
      top: -2px !important;
      left: -245px !important;
    }
  }
  .btn-add-comment{
    background:var(--primary-color)!important;
  }

}
#dark-fg-logo, #light-fg-logo,#dark-fg-logo-mobile,#light-fg-logo-mobile{
  width: 41px;
  height: 41px;
  box-shadow: 0 0 10px rgba(0,0,0,.36);
  border-radius: 2px;
  padding: 6px;
  display: flex;
  align-items: center;
  img{
    height: 100%;
    width: 100%;
  }
}
#dark-fg-logo,#dark-fg-logo-mobile{
  border: 1px solid var(--primary-color)!important;
}
#light-fg-logo, #light-fg-logo-mobile{
  background-color: #fff!important
}
  /* demo  dark logo*/
  #dark-logo ,  #dark-fg-logo ,#dark-fg-logo-mobile, #dark-logo-mobile{
    display: none;
  }
 #app.darkMode{
   #dark-logo , #dark-fg-logo , #dark-fg-logo-mobile, #dark-logo-mobile{
     display: flex;;
   }
   #light-logo , #light-fg-logo , #light-fg-logo-mobile,  #light-logo-mobile {
     display: none;
   }
 }

</style>



// WEBPACK FOOTER //
// src/App.vue